module.exports = __webpack_public_path__ + "img/head_ld.97a4347a.png";